<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>彩信</li>
                <li><a href="#">彩信草稿箱</a></li>
            </ul>
        </div>
    
        <div class="rightinfo">
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <table class="tablelist">
                <thead>
                <tr>
                    <th style="width:4%;"><input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/></th>
                    <th style="width:20%;">接收者</th>
                    <th style="width:30%;">彩信名称</th>
                    <th style="width:16%;">提交时间 </th>
                    <th style="width:10%;">审核结果</th>
                    <th style="width:10%;">备注</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in mmsCheckList" :class="{odd:index%2!=0}">
                    <td style="width:4%;"><input name="selCheck" id="selCheck"  type="checkbox" :value="item.id" /></td>
                    <td style="width:20%;">
                        <ol v-if="item.formart=='txt'"><a href="#" @click="mmsCheckInfo(item.id)">号码文件:{{item.txtSrcFileName}}</a></ol>
                        <ol v-else><a href="#" @click="mmsCheckInfo(item.id)">{{item.mobile}}</a></ol>
                    </td>
                    <td style="width:30%;">{{item.mmsSubject}}</td>
                    <td style="width:16%;">{{item.createTime}}</td>
                    <td style="width:10%;">
                        <ol v-if="item.status==0">未审核</ol>
                        <ol v-else-if="item.status==1">审核通过</ol>
                        <ol v-else-if="item.status==2">审核不通过</ol>
                    </td>
                    <td style="width:10%;">{{item.demo}}</td>
                </tr>          
                </tbody>
            </table>  
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>  
            <div class="jian">&nbsp;</div>    
        </div> 
    
        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{            
            pageIndex:0,
            totalCount:0,
            mmsCheckList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/pagemmscheck.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.mmsCheckList = res.data.mmsCheckList;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        gosmssend(mobile,content){            
            this.$router.push({
                path: '/mmssend',   
                query: {
                    mobile: mobile,
                    content: content
                }
            })
        },
        delMmsDraft(id){
            let that = this;
            let data = {'ids':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmsdraft.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除信息成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changAllCheck(){
            var checkers = document.getElementsByName('selCheck');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        plDelMmsDraft(){
            var ids = '';
            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请选择要删除的项！");
                return;
            }
            let that = this;
            let data = {'ids':ids};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmslog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除信息成功！");
                    that.pageChange(1);
                    that.cancelChecke();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        cancelChecke(){
            if(document.getElementById("allCheck").checked == true)
                document.getElementById("allCheck").checked = false;

            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    checkers[i].checked = false;
                }
            }
        },
        mmsCheckInfo(id){
            location.href = "/mmscheckinfo?id="+id;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mms/mmscheck.vue